const QuickBuyBagIcon = ({ width }) => {
    return (
        <div className={`quick-buy-icon ${width}`}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                id="uuid-ee2a23af-f671-4042-a0aa-b905ea010b82"
                viewBox="0 0 67 67"
            >
                <g
                    id="uuid-c17c64cd-3bcf-419c-bac3-35f683a6d611"
                    fill="none"
                    stroke="#414042"
                    strokeMiterlimit="10"
                    strokeWidth="7"
                >
                    <path d="M3.5 23.5h60v40h-60z"></path>
                    <path d="M21.5 33.5v-18c0-6.63 5.37-12 12-12s12 5.37 12 12v18"></path>
                </g>
            </svg>
        </div>
    )
}

export default QuickBuyBagIcon
